module.exports = __webpack_public_path__ + "img/gnosis.10dd8b02.svg";